export const isEdge = (): boolean => window.navigator.userAgent.indexOf('Edge') !== -1;
